// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-toolbar {
  --background: transparent;
  position: absolute;
}

ion-grid {
  margin-top: calc(26 * var(--width-ratio));
}

.myimage {
  width: calc(85 * var(--width-ratio));
}

.mybutton {
  --background: var(--ion-color-primary);
  width: calc(277 * var(--width-ratio));
  height: calc(42 * var(--width-ratio));
  margin: auto;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/non-eline-hospital-modal/non-eline-hospital-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,YAAA;EACA,qBAAA;AACF","sourcesContent":["ion-toolbar {\n  --background: transparent;\n  position: absolute;\n}\n\nion-grid {\n  margin-top: calc(26 * var(--width-ratio));\n}\n\n.myimage {\n  width: calc(85 * var(--width-ratio));\n}\n\n.mybutton {\n  --background: var(--ion-color-primary);\n  width: calc(277 * var(--width-ratio));\n  height: calc(42 * var(--width-ratio));\n  margin: auto;\n  --border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
